export function elapsedSecondsBetween(
  fromIso: string | null | undefined,
  nowMs: number
): number | null {
  if (!fromIso) {
    return null;
  }
  const startMs = Date.parse(fromIso);
  if (Number.isNaN(startMs)) {
    return null;
  }
  const diffMs = nowMs - startMs;
  return diffMs > 0 ? Math.floor(diffMs / 1000) : 0;
}

export function formatDuration(totalSeconds: number | null): string {
  const total = totalSeconds == null || totalSeconds < 0 ? 0 : totalSeconds;
  const seconds = total % 60;
  const minutes = Math.floor(total / 60) % 60;
  const hours = Math.floor(total / 3600);

  const ss = seconds.toString().padStart(2, "0");
  if (hours >= 1) {
    const mm = minutes.toString().padStart(2, "0");
    return `${hours}:${mm}:${ss}`;
  }
  return `${minutes}:${ss}`;
}
